var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.custUrl)?_c('section',[_c('div',{staticClass:"kefu"},[_c('a',{attrs:{"href":_vm.custUrl,"target":"_blank"}},[_c('img',{attrs:{"src":require("../assets/imgs/kefu.png"),"alt":""}})])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }